// src/components/AuthenticatedLayout.jsx
import React, { useState } from 'react';
import Sidebar from './Sidebar/Sidebar';
import MobileTopBar from './MobileTopBar/MobileTopBar';
import PortraitLock from './Responsive/PortraitLock';
import { useIsMobile } from '../hooks/useIsMobile';
import { useBackClose } from '../hooks/useBackClose';

const AuthenticatedLayout = ({ children }) => {
  const isMobile = useIsMobile();
  const [drawerOpen, setDrawerOpen] = useState(false);

  // Mobile: the OS back gesture closes the drawer instead of leaving the app.
  useBackClose(isMobile && drawerOpen, () => setDrawerOpen(false));

  // Desktop: byte-identical to the original shell.
  if (!isMobile) {
    return (
      <div className='authenticated-layout'>
        <Sidebar />
        <div className='main-content'>{children}</div>
      </div>
    );
  }

  // Mobile (≤768px): slim top bar + off-canvas drawer instead of the rail.
  return (
    <div className='authenticated-layout authenticated-layout--mobile'>
      <PortraitLock />
      <MobileTopBar onMenuClick={() => setDrawerOpen(true)} />
      <Sidebar
        variant='drawer'
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      />
      <div className='main-content main-content--mobile'>{children}</div>
    </div>
  );
};

export default AuthenticatedLayout;
